import React, { useState } from 'react';
import useAsyncEffect from 'use-async-effect';
import { WinePackageWidgetModel, getFeaturedPackages } from '../services/FeaturedPackagesService';
import { WineWidgetModel, getFeaturedWines } from '../services/FeaturedWinesService';

interface FeaturedProductContextInterface {
  featuredWines: WineWidgetModel[];
  featuredPackages: WinePackageWidgetModel[];
  isFeaturedWinesLoading: boolean;
  isFeaturedPackagesLoading: boolean;
}

const FeaturedProductContext = React.createContext<FeaturedProductContextInterface>({} as FeaturedProductContextInterface);

export const FeaturedProductProvider = ({ children }: { children: JSX.Element }) => {
  const [featuredWines, setFeaturedWines] = useState<WineWidgetModel[]>([]);
  const [featuredPackages, setFeaturedPackages] = useState<WinePackageWidgetModel[]>([]);

  const [isFeaturedWinesLoading, setIsFeaturedWinesLoading] = useState<boolean>(false);
  const [isFeaturedPackagesLoading, setIsFeaturedPackagesLoading] = useState<boolean>(false);

  useAsyncEffect(async () => {
    try {
      setIsFeaturedWinesLoading(true);
      setIsFeaturedPackagesLoading(true);

      const [featuredWines, featuredPackages] = await Promise.all([getFeaturedWines(), getFeaturedPackages()]);

      setFeaturedWines(featuredWines as WineWidgetModel[]);
      setIsFeaturedWinesLoading(false);
      setFeaturedPackages(featuredPackages as WinePackageWidgetModel[]);
      setIsFeaturedPackagesLoading(false);
    } catch (error) {
      console.error(error);
      throw new Error('Hiba az adatok betöltése során');
    }
  }, []);

  return (
    <FeaturedProductContext.Provider
      value={{
        featuredWines,
        featuredPackages,
        isFeaturedPackagesLoading,
        isFeaturedWinesLoading,
      }}
    >
      {children}
    </FeaturedProductContext.Provider>
  );
};

/**
 * Use method
 * @returns
 */
export const useFeaturedProductContext = () => {
  const context = React.useContext(FeaturedProductContext);

  if (context === undefined) {
    throw new Error('must be used within a Provider');
  }

  return context;
};
